<script setup lang="ts">
import {type HTMLAttributes} from 'vue'
import {type RadioGroupItemProps,} from 'radix-vue'
import {cn} from '@/shared/lib/utils'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";

interface Props extends RadioGroupItemProps {
  label?: String
  icon?: IconDefinition
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()

</script>

<template>
  <div
    :class="
      cn(
        'relative flex cursor-pointer bg-white p-4 shadow-sm focus:outline-none border border-slate-200 rounded-md z-0',
        props.class,
      )
    "
  >
    <div class="w-full" v-if="$slots.default">
      <slot />
    </div>
    <template v-else>
      <div class="flex flex-1 items-start h-full" :class="{'justify-center' : !label}">
        <div v-if="icon" class="flex items-center mr-3">
          <FontAwesomeIcon :icon="icon" />
        </div>
        <span class="flex flex-col">
          <span v-if="label" class="text-left block text-sm font-medium text-gray-900 pr-3">{{ label }}</span>
        </span>
      </div>
    </template>
  </div>
</template>


